module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "form-register formResponsive"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Register")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please register before submitting an article.")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "inline"
  }, [_vm._v("E-mail Address ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.email),
      expression: "register.email"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.register.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "inline"
  }, [_vm._v("Create a Password ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.register.password),
      expression: "register.password"
    }],
    staticClass: "inline",
    attrs: {
      "type": "password",
      "name": ""
    },
    domProps: {
      "value": (_vm.register.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.register, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Your E-mail address and password will allow you to log in and view, edit or delete your submissions.\n        You will receive an e-mail with the confirmation of your registration and password. ")]), _c('br'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Register"
    },
    on: {
      "click": function($event) {
        return _vm.validateRegister()
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "validation"
  }, [_vm._v(" " + _vm._s(_vm.registerValidation) + " ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dfaced04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 172
// module chunks = 2